export enum EAuthEntryPoints {
  SIGN_IN_BUTTON = 'sign_in_button',
  CREATE_ACCOUNT_BUTTON = 'create_account_button',
  APPLY_OFFERS_MODAL = 'apply_offers_modal',
  CHECKOUT_CONTACT_INFO = 'checkout_contact_info',
}
